import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wl-settings-menu',
    template: `
        <ion-list class="gutter-padding">
            <ion-item routerLink="/settings/account" routerLinkActive="active">
                <ion-icon name="person-outline" slot="start"></ion-icon>
                <ion-label>{{ 'GLOBAL.SETTINGS.ACCOUNT.MANAGE_ACCOUNT' | translate }}</ion-label>
            </ion-item>
            <ion-item routerLink="/settings/devices" routerLinkActive="active">
                <ion-icon name="phone-portrait-outline" slot="start"></ion-icon>
                <ion-label>{{ 'GLOBAL.SETTINGS.DEVICES.TITLE' | translate }}</ion-label>
            </ion-item>
            <ion-item routerLink="/settings/subscription" routerLinkActive="active">
                <ion-icon name="card-outline" slot="start"></ion-icon>
                <ion-label>{{ 'GLOBAL.SETTINGS.ACCOUNT.MANAGE_SUBSCRIPTION' | translate }}</ion-label>
            </ion-item>
            <ion-item routerLink="/settings/actions" routerLinkActive="active">
                <ion-icon name="warning-outline" slot="start"></ion-icon>
                <ion-label>{{ 'GLOBAL.SETTINGS.ACCOUNT.ACTIONS.TITLE' | translate }}</ion-label>
            </ion-item>
            <ion-item routerLink="/settings/debug" routerLinkActive="active">
                <ion-icon name="bug-outline" slot="start"></ion-icon>
                <ion-label>{{ 'GLOBAL.SETTINGS.DEBUG.TITLE' | translate }}</ion-label>
            </ion-item>
        </ion-list>
    `,
    styles: [
        `
            ion-item.active {
                --background: var(--ion-color-light, #f4f5f8);
                font-weight: 600;
            }
        `
    ]
})
export class SettingsMenuComponent {}
